/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_Large_FilesInputs */

const en_sidebar_guide_large_files = /** @type {(inputs: Sidebar_Guide_Large_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large JSON Files`)
};

const ko_sidebar_guide_large_files = /** @type {(inputs: Sidebar_Guide_Large_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일`)
};

const ja_sidebar_guide_large_files = /** @type {(inputs: Sidebar_Guide_Large_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイル`)
};

/**
* | output |
* | --- |
* | "Large JSON Files" |
*
* @param {Sidebar_Guide_Large_FilesInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_large_files = /** @type {((inputs?: Sidebar_Guide_Large_FilesInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_Large_FilesInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_large_files(inputs)
	if (locale === "ko") return ko_sidebar_guide_large_files(inputs)
	return ja_sidebar_guide_large_files(inputs)
});